(function() {
  function setRemUnit() {
    let docEl = document.documentElement
    let width = docEl.clientWidth
    if (width > 750) {
      width = 750 // 超过 750 时强制按 750 来算
    }
    docEl.style.fontSize = (width / 10) + 'px'
  }

  setRemUnit()
  window.addEventListener('resize', setRemUnit)
})();